// eslint-disable-next-line no-shadow
export enum ButtonAction {
    Story = 'story',
    Chat = 'chat'
}

export interface ContestTrigger {
    triggerKey: string
    episodeUuid: string
    rewardType: string
    rewardAmount: number
    deliveryType: string
    title: string
    message: string
}

/** Admin API shape for contests_v2 → editor Contest Trigger V2 form. */
export interface ContestTriggerV2ClientPayload {
    triggerIdentifier: string
    episodes: Array<{
        id: string
        episodeUuid: string
        branches: Array<{ id: string; branchName: string; stepIndex: number }>
    }>
    title: string
    message: string
    sapphiresAmount: number
    heartsAmount: number
}

export interface Event {
    id: number;
    title: string;
    description: string;
    imageUrl: string;
    active: boolean;
    priority: number;
    buttonText: string;
    startTime: string; // Date
    endTime: string; // Date
    label: string;
    colors: string;

    prize: null | string; // JSON.stringify({prizeType: "hearts" | "", prizeValue: string})
    buttonAction: ButtonAction;
    buttonTarget: string;

    specialRequirements: string;
    authorLabel: string;
    createdAt: string; // Date
    updatedAt: string; // Date
    contest?: ContestTrigger | null;
    contestV2?: ContestTriggerV2ClientPayload | null;

    // Operator-uploaded images and ring colour.
    cardImageUrl?: string; // derived by editor-api from cardImageObject.file_card
    detailImageUrl?: string; // derived by editor-api from modalImageObject.file_modal
    ringColor?: string | null; // #RGB or #RRGGBB; null/absent → app default
}
